export { default } from './ConfirmationCodeForm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeForm/index.js